import OrganizationsTable from './OrganizationsTable'
export default OrganizationsTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/OrganizationTab/OrganizationTable/index.js